export const LOAD_LATEST_INSTANCE = 'LOAD_LATEST_INSTANCE';
export const INSTANCE_LOADED = 'INSTANCE_LOADED';
export const LOGIN_START = 'LOGIN_START';
export const LOGIN_STARTED = 'LOGIN_STARTED';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_ERROR = 'LOGIN_ERROR';
export const LOGOUT = 'LOGOUT';

export const ENTRIES_LOAD = 'ENTRIES_LOAD';
export const ENTRIES_LOAD_STARTED = 'ENTRIES_LOAD_STARTED';
export const ENTRIES_LOAD_SUCCESS = 'ENTRIES_LOAD_SUCCESS';
export const ENTRIES_LOAD_ERROR = 'ENTRIES_LOAD_ERROR';

export const SET_PLAYERS_PAGE_SORT = 'PLAYERS_PAGE_SORT';
export const PLAYERS_PAGE_SEARCH = "PLAYERS_PAGE_SEARCH";

export const SWAP_PLAYERS = 'SWAP_PLAYERS';
export const SWAP_PLAYERS_STARTED = SWAP_PLAYERS + '_STARTED';
export const SWAP_PLAYERS_SUCCESS = SWAP_PLAYERS + '_SUCCESS';
export const SWAP_PLAYERS_ERROR = SWAP_PLAYERS + '_ERROR';

export const DELETE_REGISTRATION_ENTRY = 'DELETE_REG_ENTRY';
export const DELETE_REGISTRATION_ENTRY_STARTED = DELETE_REGISTRATION_ENTRY + "_STARTED";
export const DELETE_REGISTRATION_ENTRY_SUCCESS = DELETE_REGISTRATION_ENTRY + "_SUCCESS";
export const DELETE_REGISTRATION_ENTRY_ERROR = DELETE_REGISTRATION_ENTRY + "_ERROR";

export const EDIT_REGISTRATION_ENTRY = 'EDIT_REG_ENTRY';
export const EDIT_REGISTRATION_ENTRY_PLAYERS = EDIT_REGISTRATION_ENTRY + "_PLAYERS";

export const UPDATE_REGISTRATION_ENTRY = 'UPDATE_REG_ENTRY';
export const UPDATE_REGISTRATION_ENTRY_STARTED = UPDATE_REGISTRATION_ENTRY + "_STARTED";
export const UPDATE_REGISTRATION_ENTRY_SUCCESS = UPDATE_REGISTRATION_ENTRY + "_SUCCESS";
export const UPDATE_REGISTRATION_ENTRY_ERROR = UPDATE_REGISTRATION_ENTRY + "_ERROR";
export const UPDATE_REGISTRATION_ENTRY_RESET = UPDATE_REGISTRATION_ENTRY + "_RESET";

export const loadLatestInstance = (series) => {
    return {
        type: LOAD_LATEST_INSTANCE,
        series: series
    }
};

export const onInstanceLoaded = (instance) => {
    return {
        type: INSTANCE_LOADED,
        instance: instance
    }
};

export const swapPlayers = (regEntryId, jwtToken) => {
    return {
        type: SWAP_PLAYERS,
        regEntryId: regEntryId,
        jwtToken: jwtToken
    }
};

export default {LOAD_LATEST_INSTANCE, INSTANCE_LOADED, LOGIN_START, LOGIN_STARTED, LOGIN_SUCCESS, LOGIN_ERROR,
    ENTRIES_LOAD, ENTRIES_LOAD_STARTED, ENTRIES_LOAD_SUCCESS, ENTRIES_LOAD_ERROR, SET_PLAYERS_PAGE_SORT,
    SWAP_PLAYERS, SWAP_PLAYERS_STARTED, SWAP_PLAYERS_SUCCESS, SWAP_PLAYERS_ERROR, DELETE_REGISTRATION_ENTRY,
    DELETE_REGISTRATION_ENTRY_STARTED, DELETE_REGISTRATION_ENTRY_SUCCESS, DELETE_REGISTRATION_ENTRY_ERROR,
    LOGOUT, UPDATE_REGISTRATION_ENTRY, UPDATE_REGISTRATION_ENTRY_SUCCESS, UPDATE_REGISTRATION_ENTRY_STARTED,
    UPDATE_REGISTRATION_ENTRY_ERROR, UPDATE_REGISTRATION_ENTRY_RESET, EDIT_REGISTRATION_ENTRY,
    EDIT_REGISTRATION_ENTRY_PLAYERS, PLAYERS_PAGE_SEARCH,
    loadLatestInstance, onInstanceLoaded, swapPlayers};